var _defs, _path, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack112({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.6,4h0A2,2,0,0,0,10.38,2.9,2.24,2.24,0,0,0,8.44,1.8H8.38a2.24,2.24,0,0,0-2,1.1A2,2,0,0,0,3.25,4h0a1.81,1.81,0,0,0,0,3.61,1.77,1.77,0,0,0,.69-.14,2.48,2.48,0,0,0,2.5,1.8,2.7,2.7,0,0,0,2-.86,2.66,2.66,0,0,0,2,.86,2.48,2.48,0,0,0,2.5-1.8,1.77,1.77,0,0,0,.69.14A1.81,1.81,0,1,0,13.6,4Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 4.26,
    cy: 11.43,
    rx: 1.33,
    ry: 1.03
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 1.5,
    cy: 13.5,
    rx: 0.91,
    ry: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack112);
export default __webpack_public_path__ + "static/media/Symbolpack_1_12.8ecabed48ab57bd4260adabe167320fb.svg";
export { ForwardRef as ReactComponent };